module.exports = __webpack_public_path__ + "assets/people/klimChe.3dd786220f85422727dff2cf5a029add.png";